var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marker-action"},[_c('list-action-form',{ref:"form",attrs:{"ids":_vm.ids,"labels":_vm.labels,"route":_vm.route,"method":_vm.method,"button-class":_vm.buttonClass,"form-class":_vm.formClass},on:{"submitted":_vm.submit}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }